module.exports = __webpack_public_path__ + "img/vegetable-lambs-quarters-190x100.2acb235b.jpg";